<template>
  <div>
    <table>
      <thead>
        <tr>
          <th class="line0" colspan="3">PROGRAMAÇÃO FINAL</th>
        </tr>
      </thead>
      <tbody>
        <tr class="lineB">
          <td rowspan="2">Horário<br></td>
          <td colspan="2">Salas</td>
        </tr>
        <tr class="lineB">
          <td>Sala 1</td>
          <td >Sala 2</td>
        </tr>
        <tr>
          <td class="days" colspan="3">QUARTA-FEIRA - 07/04/2021</td>
        </tr>
        <tr class="lineB">
          <td>9:30 - 10:00</td>
          <td colspan="2">ABERTURA DO PLURIS 2021</td>
        </tr>
        <tr class="lineA">
          <td>10:00 - 11:00</td>
          <td colspan="2">PALESTRA MAGNA<br>
            Planning Support Science: past – present - future
            <br>Stan Geertman <br>
            Professor of Planning Support Science at Utrecht University, the Netherlands
          </td>
        </tr>
        <tr class="lineB">
          <td>11:00 - 11:15</td>
          <td colspan="2">VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS</td>
        </tr>
        <tr class="lineA">
          <td>11:15 - 12:15</td>
          <td colspan="2">PALESTRA MAGNA <br>Os desafios
          para aplicação da Nova Agenda Urbana nas cidades brasileiras
          <br>Daniel Todtmann Montandon<br>Diretor de Arquitetura e
          Urbanismo na Universidade Nove de Julho</td>
        </tr>
        <tr >
          <td class="days">12:15 - 14:00</td>
          <td class="days" colspan="2">
            INTERVALO ALMOÇO E VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS
          </td>
        </tr>
        <tr class="lineA">
          <td>14:00 - 15:30</td>
          <td>PAINEL TEMÁTICO 1: Clima e Planejamento I</td>
          <td>PAINEL TEMÁTICO 2: Transporte e Uso do Solo</td>
        </tr>
        <tr class="lineB">
          <td>15:30 - 16:00</td>
          <td colspan="2">VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS</td>
        </tr>
        <tr class="lineA">
          <td>16:00 - 17:30</td>
          <td>PAINEL TEMÁTICO 3: Planejamento de Espaços de Uso Público</td>
          <td>PAINEL TEMÁTICO 4: Planejamento e Meio Ambiente</td>
        </tr>
        <tr>
          <td class="days" colspan="3">QUINTA-FEIRA - 08/04/2021</td>
        </tr>
        <tr class="lineA">
          <td>10:00 - 11:00</td>
          <td colspan="2">PALESTRA MAGNA<br>Inequality in Transport
          <br>David Banister<br>Emeritus Professor of Transport Studies
          at the School of Geography and the Environment (SoGE) and the
          Transport Studies Unit of University of Oxford</td>
        </tr>
        <tr class="lineB">
          <td>11:00 - 11:15</td>
          <td colspan="2">VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS</td>
        </tr>
        <tr class="lineA">
          <td>11:00 - 12:00</td>
          <td colspan="2">PALESTRA MAGNA   <br>Clima e Planejamento urbano<br>
          Eleonora Sad de Assis<br> Arquiteta e Urbanista, com ênfase em Adequação
          Ambiental e professora da Universidade Federal de Minas Gerais</td>
        </tr>
        <tr>
          <td class="days">12:00 - 14:00</td>
          <td class="days" colspan="2">
            INTERVALO ALMOÇO E VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS
          </td>
        </tr>
        <tr class="lineA">
          <td>14:00 - 15:45<br></td>
          <td>PAINEL TEMÁTICO 5: Clima e Planejamento II</td>
          <td>PAINEL TEMÁTICO 6: Mobilidade Urbana</td>
        </tr>
        <tr class="lineB">
          <td>15:45 - 16: 15</td>
          <td colspan="2">VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS</td>
        </tr>
        <tr class="lineA">
          <td>16:15 - 18:00</td>
          <td>PAINEL TEMÁTICO 7: Tecnologia da Informação Aplicada ao
           Planejamento de Mobilidade</td>
          <td>PAINEL TEMÁTICO 8: Planejamento Urbano e Regional</td>
        </tr>
        <tr>
          <td class="days" colspan="3">SEXTA-FEIRA - 09/04/2021</td>
        </tr>
        <tr class="lineA">
          <td>8:30 - 9:30</td>
          <td>PALESTRA  SETORIAL<br>Experiências de elaboração de políticas públicas
          para o
          turismo<br> Renata Maria Ribeiro<br>Professora assistente doutora da Universidade
          Estadual Paulista Júlio de Mesquita Filho - UNESP</td>
          <td>PALESTRA SETORIAL<br>Como oito cidades catarinenses desenvolveram juntas seus planos
          de mobilidade<br>Renata Cavion, Simone B Lopes e Andréa Holz<br>
          Professoras da Universidade Federal de Santa Catarina - UFSC
          </td>
        </tr>
        <tr class="lineA">
          <td>09:30 - 10:30</td>
          <td>PAINEL TEMÁTICO 9: Questões Socioeconômicas, de saúde e planejamento</td>
          <td>PAINEL TEMÁTICO 10: Habitação e Planejamento Urbano</td>
        </tr>
        <tr class="lineB">
          <td>10:30 - 10:45</td>
          <td colspan="2">VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS</td>
        </tr>
        <tr class="lineB">
          <td>10:45 - 12:00</td>
          <td colspan="2">ENCERRAMENTO E DIVULGAÇÃO DOS MELHORES TRABALHOS DO CONGRESSO</td>
        </tr>
        <tr>
          <td class="days">12:00 - 14:00</td>
          <td class="days" colspan="2">
            INTERVALO ALMOÇO E VISITAÇÃO ÀS SESSÕES TÉCNICAS ASSÍNCRONAS
          </td>
        </tr>
      </tbody>
      </table>
  </div>
</template>

<script>
export default {
  name: 'Schedule',
};
</script>

<style scoped>
table{
  border-spacing: 0px;
}

th, td {
  font-weight: normal;
  padding: 5px;
}

.title {
  background-color: #2f5496;
  color: white;
}

.line0 {
  background-color: #2f5496;
  color: white;
  font-weight: bold;
}

td {
  border-right: 0.5px solid #C8C8C8;
  border-bottom: 0.5px solid #C8C8C8;
}

.days {
  background-color: #8eaadb;
  font-weight: 900;
}

.lineA {
  background-color: #d6e1f2;
}

.lineB {
  background-color: #ebf0f9;
}

.noBorderBottom {
  border-bottom: 0px !important;
}

.noBorderRight {
  border-right: 0px !important;
}

.dayTitle {
  font-size: 0.8em;
}

.message {
  color: #2f5496;
  font-weight: bold;
  text-align: justify;
}
</style>
